import ReactSelect from "react-select";
import { FieldValues, UseFormRegister } from "react-hook-form";
import { colourStyles } from "../utils/reactSelectConfig";
import useSettings from "../hooks/useSettings";
import useTranslate from "../hooks/useTranslate";
import { IBasket } from "../@interfaces/basket.interface";
// styles
import styles from "../styles/Select.module.css";

const isBasket = (param: IBasket): param is IBasket => {
  return !!param?.code
}

interface ISelect {
  id?: string;
  label?: string;
  optionsList: any[];
  onChange: (v: any | string | null) => void;
  onOffsetClick?: (params: { basket?: IBasket, currency?: string }) => void;
  register?: UseFormRegister<FieldValues>;
  selectedItem?: any;
  className?: string;
  noTranslate?: boolean;
}

const Select: React.FC<ISelect> = ({
  id,
  label,
  optionsList,
  onChange,
  onOffsetClick,
  register,
  selectedItem,
  noTranslate,
  className
}) => {
  const { language } = useSettings();
  const { translatedText } = useTranslate(label || '', language);

  const listProps = {
    register: register && id && register(id),
  };
  
  return (
  <div className={className}>
    {optionsList?.length > 0 && (
    <div className={`${styles.customSelect} delayed-fadein`}>
    {label && <label className={`${styles.inputLabel} translate-dynamic`} htmlFor={id}>{translatedText}</label>}
    <div style={{ zIndex: 999 }}>
      <ReactSelect
        inputId={id}
        value={selectedItem || optionsList[0]}

        captureMenuScroll={false}
        menuPortalTarget={document.body}

        options={optionsList}
        classNames={{
          option: (state) => `delayed-fadein ${noTranslate ? 'no-translate' : 'translate-dynamic'}`,
        }}
        components={{
          IndicatorSeparator:() => null
        }}
        classNamePrefix="custom-react-select"
        onChange={(item) => {
          if (item) {
            onChange(item);
          }

          if (onOffsetClick) {
            if (isBasket(item)) {
              onOffsetClick({ basket: item })
            } else {
              onOffsetClick({ currency: item.value })
            }
            
          }
        }}
        styles={colourStyles}
        theme={(theme) => ({
          ...theme,
          borderRadius: 6,
          padding: 0,
          colors: {
            ...theme.colors,
            primary: 'var(--fow-gray-light-color)',
          },
        })}
        {...listProps}
      />
    </div>
      </div>
    )}
  </div>
  );
};

export default Select;
